import {Component , OnInit} from '@angular/core';
import {fuseAnimations} from '../../../../core/animations';
import {ActivatedRoute} from '@angular/router';
import {OrganizationsService} from '../../../../core/services/organizations.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../../core/services/users.service';
import { checkEmailOnServer, emailValidator } from '../../../../core/validators/validators';
import {CheckModalComponent} from '../../check-save-modal/check-modal';
import {Observable} from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _ from 'lodash';
import {NgxSpinnerService} from 'ngx-spinner';
import {FuseDeleteDialogComponent} from '../../../../core/components/delete-dialog/delete-dialog.component';
import {ToastrService } from 'ngx-toastr';
import {FuseConfigService} from '../../../../core/services/config.service';
import {FuncionTypeService} from '../../../../core/services/functionType.service';
import { EventService } from '../../../../core/services/event.service';
import {ModulesService} from '../../../../core/services/modules.service';

@Component({
    selector: 'user-detail-page',
    templateUrl: './user-detail.component.html',
    styleUrls: ['./user-detail.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class UserDetailComponent implements OnInit {
  user;
  public formGroup: any = new FormGroup({
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    roleId: new FormControl('', Validators.required),
    functionTypeId: new FormControl(),
    email: new FormControl('', [emailValidator , checkEmailOnServer, Validators.required]),
    countryId: new FormControl({value: '', disabled: true}, Validators.required),
    cityId: new FormControl({value: '', disabled: true}, Validators.required),
    organizationId: new FormControl({value: '', disabled: true}, Validators.required),
    lang: new FormControl(),
    eCall: new FormControl(),
    phone: new FormControl(),
    isMainAdmin: new FormControl({value: null, disabled: true}),
    canRecommend: new FormControl({value: null, disabled: true}),
    isSecretariat: new FormControl({value: null, disabled: true}),
    isSafeguard: new FormControl({value: null, disabled: true}),
  });
  public img;
  public uploadedImg = null;
  public countries = [];
  public cities = [];
  public organizations = [];
  public defaultForm;
  public defaultImg;
  public returnBack;
  public logo;
  public languages = [ {label: 'Germany' , value: 'de'},  {label: 'English' , value: 'en'} , {label: 'French' , value: 'fr'} ];
  public language;
  public roles: any = [];
  public functions: any = [];
  public adminRole = '';

  constructor (private route: ActivatedRoute ,
               private spinner: NgxSpinnerService ,
               public toastr: ToastrService  ,
               private fuseConfig: FuseConfigService ,
               private userService: UserService ,
               private router: Router , private organizationService: OrganizationsService ,
               public translate: TranslateService , private functionTypeService: FuncionTypeService,
               public dialog: MatDialog , public snackBar: MatSnackBar, public eventService: EventService,
               private modulesService: ModulesService) {
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  ngOnInit () {
    this.spinner.show();
    const id = this.route.snapshot.queryParamMap.get('id');
    this.userService.getUserById(id).subscribe((data: any) => {
      if (data.logo) {
        this.img = data.logo;
        this.logo = data.logo;
        this.defaultImg = this.img;
      }
      this.user = data;
      this.language = this.user.lang;
      this.organizationService.getCountry().subscribe((result: any) => {
        this.countries = result;
        this.userService.getRoles().subscribe((roleResult: any) => {
          this.roles = roleResult;
          this.functionTypeService.getFunctionTypeDropDown().subscribe((resFunction: any) => {
            this.functions = resFunction;
            this.initForm(this.user);
            setTimeout(() => {
              this.spinner.hide();
            } , 500);
          });
        });
      });
    });
  }

  initForm (data) {
    this.formGroup.controls.email.setValidators(emailValidator);
    this.fuseConfig.role.subscribe(res => {
      this.adminRole = res;
      const selectControlCountry = this.formGroup.get('countryId');
      const selectControlCanton = this.formGroup.get('cityId');
      const selectControlOrganization = this.formGroup.get('organizationId');
      const selectControlLang = this.formGroup.get('lang');
      if (res && res === 'countryAdmin') {
        selectControlCountry.disable({emitEvent: false});
        selectControlCanton.enable({emitEvent: false});
        selectControlOrganization.enable({emitEvent: false});
        selectControlLang.enable({emitEvent: false});
      }
      if (res && res === 'subCountryAdmin') {
        selectControlCountry.disable({emitEvent: false});
        selectControlCanton.disable({emitEvent: false});
        selectControlOrganization.enable({emitEvent: false});
        selectControlLang.enable({emitEvent: false});
      }
      if (res && res === 'organisationAdmin') {
        selectControlCountry.disable({emitEvent: false});
        selectControlCanton.disable({emitEvent: false});
        selectControlOrganization.disable({emitEvent: false});
        selectControlLang.enable({emitEvent: false});
      }
      if (data.hasOwnProperty('roleId') && +data.roleId === 4 && res === 'superAdmin') {
        const inputControlMainAdmin = this.formGroup.get('isMainAdmin');
        inputControlMainAdmin.enable();
      }
      if (data.hasOwnProperty('roleId') && +data.roleId === 3 && res === 'superAdmin') {
        const inputControlCanRecommend = this.formGroup.get('canRecommend');
        inputControlCanRecommend.enable();
      }
    });
    this.formGroup.get('countryId').valueChanges.subscribe((res) => {
      if (res) {
        this.organizationService.getCity(res).subscribe((result: any) => {
          this.cities = result;
          if (data && data.cityId) {
            this.formGroup.patchValue({cityId: data.cityId});
          }
        });
      }
    });

    this.formGroup.get('cityId').valueChanges.subscribe((res) => {
      if (res) {
        this.organizationService.getOrganizationByCity(res).subscribe((result: any) => {
          this.organizations = result;
          if (data && data.organizationId) {
            this.formGroup.patchValue({organizationId: data.organizationId});
          }
        });
      }
    });
    this.formGroup.get('organizationId').valueChanges.subscribe((res) => {
      if (res) {
        this.getModules(res);
      }
    });
    this.formGroup.get('roleId').valueChanges.subscribe((res) => {
      const selectControlCountry = this.formGroup.get('countryId');
      const selectControlCanton = this.formGroup.get('cityId');
      const selectControlOrganization = this.formGroup.get('organizationId');
      if (res === 2) {
        selectControlCountry.setValidators(Validators.required);
        selectControlCanton.clearValidators({emitEvent: false});
        selectControlOrganization.clearValidators({emitEvent: false});
        selectControlCountry.enable({emitEvent: false});
        selectControlCanton.disable({emitEvent: false});
        selectControlOrganization.disable({emitEvent: false});
      } else if (res === 3) {
        selectControlCountry.setValidators(Validators.required);
        selectControlCanton.setValidators(Validators.required);
        selectControlOrganization.clearValidators({emitEvent: false});
        selectControlCountry.enable({emitEvent: false});
        selectControlCanton.enable({emitEvent: false});
        selectControlOrganization.disable({emitEvent: false});
      } else {
        selectControlCountry.setValidators(Validators.required);
        selectControlCanton.setValidators(Validators.required);
        selectControlOrganization.setValidators(Validators.required);
        selectControlCountry.enable({emitEvent: false});
        selectControlCanton.enable({emitEvent: false});
        selectControlOrganization.enable({emitEvent: false});
      }
      if (this.adminRole === 'countryAdmin') {
        selectControlCountry.disable({emitEvent: false});
      }
      if (this.adminRole === 'subCountryAdmin') {
        selectControlCountry.disable({emitEvent: false});
        selectControlCanton.disable({emitEvent: false});
      }
      if (this.adminRole === 'organisationAdmin') {
        selectControlCountry.disable({emitEvent: false});
        selectControlCanton.disable({emitEvent: false});
        selectControlOrganization.enable({emitEvent: false});
      }
      selectControlCountry?.updateValueAndValidity({emitEvent: false});
      selectControlCanton?.updateValueAndValidity({emitEvent: false});
      selectControlOrganization?.updateValueAndValidity({emitEvent: false});
    });
    this.formGroup.patchValue(data);
    if (this.countries.length === 1) {
      this.formGroup.patchValue({countryId: this.countries[ 0 ].id});
    }
    if (this.cities.length === 1) {
      this.formGroup.patchValue({cityId: this.cities[ 0 ].id});
    }
    if (this.organizations.length === 1) {
      this.formGroup.patchValue({organizationId: this.organizations[ 0 ].id});
    }
    this.defaultForm = this.formGroup.getRawValue();
  }


  updateUser (returnToUser) {
    const data = this.formGroup.getRawValue();
    if (+data.roleId === 2) {
      data.cityId = '';
      data.organizationId = '';
    }
    if (+data.roleId === 3) {
      data.organizationId = '';
    }
    data.file = this.uploadedImg;
    data.id = this.user.id;
    if (data.isMainAdmin) {
      this.userService.checkOrgMainAdmin(data.id, data.organizationId).subscribe((result: any) => {
        if (result && result.canBeAdmin) {
          this.userService.addUser(data).subscribe((res: any) => {
            this.toastr.success('Admin updated' , 'Success!');
            this.returnBack = returnToUser;
            if (res && returnToUser) {
              this.userService.updateSuccess = true;
              this.router.navigate([ './pages/users' ]);
            }
          });
        } else {
          this.toastr.error('Dieser User kann kein Administrator sein', 'Error!');
        }
      });
    } else {
      this.userService.addUser(data).subscribe((res) => {
        this.toastr.success('Admin updated' , 'Success!');
        this.returnBack = returnToUser;
        if (res && returnToUser) {
          this.userService.updateSuccess = true;
          this.router.navigate([ './pages/users' ]);
        }
      });
    }
  }

  deleteUser () {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.userService.deleteUser(this.user.id).subscribe((res) => {
          this.toastr.success('User deleted' , 'Success!');
          this.router.navigate([ './pages/users' ]);
        });
      }
    });
  }

  canDeactivate (): Observable<boolean> | boolean {
    return this.goBack();
  }

  goBack (): any {
    let dialogRef;
    if (!this.compareForms() && !this.returnBack) {
      dialogRef = this.dialog.open(CheckModalComponent , {
        panelClass: 'unsave-form-dialog',
        width: '400px',
      });

      return dialogRef.afterClosed().toPromise().then((result: any) => {
        if (result === 'leave') {
          return true;
        } else if (result === 'save') {
          if (this.formGroup.valid) {
            this.updateUser(false);
            return true;
          } else {
            this.snackBar.open('Please fill forms correctly' , '' , {duration: 2500});
            return false;
          }
        }
      });
    } else {
      return true;
    }
  }

  compareForms () {
    return _.isEqual(this.formGroup.getRawValue() , this.defaultForm) && (this.defaultImg === this.img);
  }

  setImg (img) {
    this.uploadedImg = img;
  }

  blockUser () {
    this.userService.blockUser({id: this.user.id}).subscribe((res) => {
      if (res) {
        this.user = res;
      }
    });
  }
  sendEmail() {
     this.userService.sendEmailPass(this.user.id).subscribe((res) => {
       this.toastr.success('Email sent' , 'Success!');
     });
  }

  changeLang(lang){
    this.formGroup.patchValue({lang: lang.value});
  }

  getModules(organizationId) {
    this.modulesService.getByOrganizationId(organizationId).subscribe((res: any) => {
      if (res?.length) {
        const forumTalkEnabled = res.find(module => +module.id === 6 && !!module.status);
        const inputControlSecretariat = this.formGroup.get('isSecretariat');
        const inputControlSafeguard = this.formGroup.get('isSafeguard');
        if (forumTalkEnabled) {
          inputControlSecretariat.enable();
          inputControlSafeguard.enable();
        } else {
          inputControlSecretariat.disable();
          inputControlSafeguard.disable();
        }
      }
    });
  }
}
